import * as React from 'react';
import { Prelanding } from '@cian/frontend-val-my-home-banner';
import { useSelector } from 'react-redux';
import { selectUserId } from '../../selectors/user';

type TUserId = number | undefined;

export const PrelandingContainer: React.FC = () => {
  const userId = useSelector(selectUserId) as TUserId;

  return <Prelanding userId={userId} />;
};
